<template>
  <svg width="100%" height="100%" viewBox="0 0 1004 1004" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
      <g transform="matrix(1,0,0,1,-5795.53,-2225.74)">
          <g transform="matrix(2.55135e-16,-4.16667,4.16667,2.55135e-16,2113.5,11446.4)">
              <g>
                  <g transform="matrix(-1,0,0,1,4074.07,-614.105)">
                      <rect x="2027.78" y="1497.79" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-614.105)">
                      <rect x="2138.89" y="1497.79" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-577.068)">
                      <rect x="2027.78" y="1479.28" width="18.52" height="18.518" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-577.068)">
                      <rect x="2046.3" y="1479.28" width="18.518" height="18.518" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-577.068)">
                      <rect x="2120.37" y="1479.28" width="18.518" height="18.518" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-577.068)">
                      <rect x="2138.89" y="1479.28" width="18.52" height="18.518" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-540.033)">
                      <rect x="2027.78" y="1460.76" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-540.033)">
                      <rect x="2046.3" y="1460.76" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4148.15,-540.033)">
                      <rect x="2064.81" y="1460.76" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4222.22,-540.033)">
                      <rect x="2101.85" y="1460.76" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-540.033)">
                      <rect x="2120.37" y="1460.76" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-540.033)">
                      <rect x="2138.89" y="1460.76" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,3962.96,-502.995)">
                      <rect x="1972.22" y="1442.24" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4000,-502.995)">
                      <rect x="1990.74" y="1442.24" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4037.04,-502.995)">
                      <rect x="2009.26" y="1442.24" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-502.995)">
                      <rect x="2046.3" y="1442.24" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4148.15,-502.995)">
                      <rect x="2064.81" y="1442.24" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4222.22,-502.995)">
                      <rect x="2101.85" y="1442.24" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-502.995)">
                      <rect x="2120.37" y="1442.24" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4333.33,-502.995)">
                      <rect x="2157.41" y="1442.24" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4370.37,-502.995)">
                      <rect x="2175.93" y="1442.24" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4407.41,-502.995)">
                      <rect x="2194.45" y="1442.24" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4000,-465.959)">
                      <rect x="1990.74" y="1423.72" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4037.04,-465.959)">
                      <rect x="2009.26" y="1423.72" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-465.959)">
                      <rect x="2027.78" y="1423.72" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4148.15,-465.959)">
                      <rect x="2064.81" y="1423.72" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4222.22,-465.959)">
                      <rect x="2101.85" y="1423.72" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-465.959)">
                      <rect x="2138.89" y="1423.72" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4333.33,-465.959)">
                      <rect x="2157.41" y="1423.72" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4370.37,-465.959)">
                      <rect x="2175.93" y="1423.72" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4037.04,-428.921)">
                      <rect x="2009.26" y="1405.2" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-428.921)">
                      <rect x="2027.78" y="1405.2" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-428.921)">
                      <rect x="2046.3" y="1405.2" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-428.921)">
                      <rect x="2120.37" y="1405.2" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-428.921)">
                      <rect x="2138.89" y="1405.2" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4333.33,-428.921)">
                      <rect x="2157.41" y="1405.2" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4185.19,-391.885)">
                      <rect x="2083.33" y="1386.68" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4037.04,-354.847)">
                      <rect x="2009.26" y="1368.16" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-354.847)">
                      <rect x="2027.78" y="1368.16" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-354.847)">
                      <rect x="2046.3" y="1368.16" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-354.847)">
                      <rect x="2120.37" y="1368.16" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-354.847)">
                      <rect x="2138.89" y="1368.16" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4333.33,-354.847)">
                      <rect x="2157.41" y="1368.16" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4000,-317.811)">
                      <rect x="1990.74" y="1349.65" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4037.04,-317.811)">
                      <rect x="2009.26" y="1349.65" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-317.811)">
                      <rect x="2027.78" y="1349.65" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4148.15,-317.811)">
                      <rect x="2064.81" y="1349.65" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4222.22,-317.811)">
                      <rect x="2101.85" y="1349.65" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-317.811)">
                      <rect x="2138.89" y="1349.65" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4333.33,-317.811)">
                      <rect x="2157.41" y="1349.65" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4370.37,-317.811)">
                      <rect x="2175.93" y="1349.65" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,3962.96,-280.773)">
                      <rect x="1972.22" y="1331.13" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4000,-280.773)">
                      <rect x="1990.74" y="1331.13" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4037.04,-280.773)">
                      <rect x="2009.26" y="1331.13" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-280.773)">
                      <rect x="2046.3" y="1331.13" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4148.15,-280.773)">
                      <rect x="2064.81" y="1331.13" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4222.22,-280.773)">
                      <rect x="2101.85" y="1331.13" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-280.773)">
                      <rect x="2120.37" y="1331.13" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4333.33,-280.773)">
                      <rect x="2157.41" y="1331.13" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4370.37,-280.773)">
                      <rect x="2175.93" y="1331.13" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4407.41,-280.773)">
                      <rect x="2194.45" y="1331.13" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-243.735)">
                      <rect x="2027.78" y="1312.61" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-243.735)">
                      <rect x="2046.3" y="1312.61" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4148.15,-243.735)">
                      <rect x="2064.81" y="1312.61" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4222.22,-243.735)">
                      <rect x="2101.85" y="1312.61" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-243.735)">
                      <rect x="2120.37" y="1312.61" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-243.735)">
                      <rect x="2138.89" y="1312.61" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-206.699)">
                      <rect x="2027.78" y="1294.09" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4111.11,-206.699)">
                      <rect x="2046.3" y="1294.09" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4259.26,-206.699)">
                      <rect x="2120.37" y="1294.09" width="18.518" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-206.699)">
                      <rect x="2138.89" y="1294.09" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4074.07,-169.661)">
                      <rect x="2027.78" y="1275.57" width="18.52" height="18.519" class="filled-square"/>
                  </g>
                  <g transform="matrix(-1,0,0,1,4296.3,-169.661)">
                      <rect x="2138.89" y="1275.57" width="18.52" height="18.519" class="filled-square"/>
                  </g>
              </g>
          </g>
      </g>
  </svg>
</template>

<script>
export default {
  name: 'christmas-decoration'
}
</script>

<style lang="scss" scoped>
  .filled-square {
    fill: currentColor;
  }
</style>
